import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Company, Offer } from "../../models/Companies";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Companies form
 */

export class CompanyOfferForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Product ID',
      name: 'productId'
    }, {
      label: 'Компания',
      name: 'companyId',
      required: true,
      type: BaseForm.TYPES.AUTOCOMPLETE,
      props: {
        common: {
          dataState: StateSelector.companies.list,
          dataFetch: DispatchSelector.companies.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        }
      }
    }, {
      label: 'Цена',
      name: 'price'
    }, {
      label: 'Закупочная цена',
      name: 'purchasePrice'
    }, {
      label: 'Наличие',
      name: 'isAvailable',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Остаток, шт.',
      name: 'restCount'
    }, {
      label: 'Забронировано, шт.',
      name: 'holdCount'
    }, {
      label: 'Тип обновления цены',
      name: 'updatedType',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Offer.updatedTypeTitles)
        }
      }
    }, {
      label: 'Весовой',
      name: 'isWeight',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Баланс веса',
      name: 'weightBalance'
    }, {
      label: 'Значение до цены',
      name: 'pricePrefix'
    }, {
      label: 'Значение после цены',
      name: 'pricePostfix'
    }, {
      label: 'Способ продажи',
      name: 'sellingType',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Company.companiesSellingTypes)
        }
      }
    }];
    this.dispatchCreateForm = DispatchSelector.companiesOffers.create;
    this.dispatchUpdateForm = DispatchSelector.companiesOffers.update;
    this.responseCreateState = StateSelector.companiesOffers.create;
    this.responseUpdateState = StateSelector.companiesOffers.update;
  }

}